import styled from 'styled-components'

export const FieldCheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`
export const FieldCheckboxIndicator = styled.div`
  width: ${props => (props.size === 'default' ? 30 : 24)}px;
  height: ${props => (props.size === 'default' ? 30 : 24)}px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => (props.checked ? props.theme.color.primary : props.theme.color.lineInverted)};
  border-radius: 16px;

  svg {
    width: 50%;
    height: 50%;
    fill: ${props => (props.checked ? props.theme.color.white : props.theme.color.global)};
  }
`
export const FieldCheckboxLabel = styled.span`
  padding-left: 15px;
`
